import React from 'react';
import ContactForm from '../ContactForm';

const ContactPage = () => (
    <div className="page-content">
        <ContactForm />
    </div>
);

export default ContactPage;
